import React, { useEffect } from 'react'
// import { ENVIROMENT } from './config'
import { BrowserRouter } from 'react-router-dom'
import AppRoutes from './routes'
import { Toaster, Loader } from './components'
import { useAppDispatch, useAppSelector } from './redux/hook'
import { HIDE_LOADER } from './redux/slices/LoaderSlice'
import IdleTimer from './components/IdlePrompt'
const App: React.FunctionComponent = () => {
    const dispatch = useAppDispatch()
    // const isProduction = ENVIROMENT === 'production'
    const notification = useAppSelector((state) => state.showNotification)
    const isLoader = useAppSelector((state) => state.loader)
    const state = useAppSelector((state) => state.persistedReducers.auth)
    useEffect(() => {
        dispatch(HIDE_LOADER())
    }, [])

    const handletimeout = () => {
        // alert('here')
    }

    return (
        <>
            {notification.show && <Toaster />}
            {isLoader.show && <Loader />}
            <BrowserRouter>
                {state.isUser && (
                    <IdleTimer
                        timeout={55 * 60 * 1000}
                        onTimeout={handletimeout}
                    />
                )}
                <AppRoutes />
            </BrowserRouter>
        </>
    )
}

export default App
